<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>BUILD</div>
				<h2 waHeading="l" waText>Build-Time Code Generation</h2>
				<p waBody="m" waColorText="quiet" waText>Java compiles &rarr; TypeScript generates &rarr; Angular builds &rarr; JAR packages.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<markdown [data]="mdContent_27"></markdown>
				<div class="mermaid-diagram-wrapper">
					<div class="mermaid-diagram-label" waCaption="s" waFontWeight="semibold" waText>Build Flow</div>
					<div class="mermaid-diagram">
						<markdown [data]="mdContent_28" mermaid></markdown>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>